/* 99Glow storefront sections — shared behaviour. Scoped to [data-g99-*] hooks; safe to load more than once. */
(function () {
  if (window.__g99Loaded) { document.dispatchEvent(new Event('g99:init')); return; }
  window.__g99Loaded = true;

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (root.__g99) return; root.__g99 = true;
    var thumbs = qsa(root, '[data-g99-thumb]');
    var slides = qsa(root, '[data-g99-slide]');
    function show(i) {
      slides.forEach(function (s, n) {
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
        var v = s.querySelector('video'); if (v && n !== i) { try { v.pause(); } catch (e) {} }
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var active = thumbs[i];
      if (active && active.scrollIntoView && root.closest('.g99') && window.innerWidth < 990) {
        active.parentNode.scrollTo({ left: active.offsetLeft - 20, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.g99Show = function (mediaId) {
      for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') === String(mediaId)) { show(i); return; } }
    };
    // swipe on main image (touch)
    var main = root.querySelector('.g99-gal__main'); var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        var cur = slides.findIndex(function (s) { return s.getAttribute('aria-hidden') === 'false'; });
        var nxt = (cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length; show(nxt);
      });
    }
  }

  /* ---------- Buy form: variants + offers ---------- */
  function initBuy(form) {
    if (form.__g99) return; form.__g99 = true;
    var dataEl = form.querySelector('script[data-g99-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-g99-variant-id]');
    var btn = form.querySelector('[data-g99-submit]');
    var btnLabel = btn ? btn.getAttribute('data-label') : '';
    var stock = form.querySelector('[data-g99-stock]');
    var threshold = parseInt(form.getAttribute('data-low-stock') || '0', 10);
    var gallery = document.querySelector(form.getAttribute('data-gallery') || '') ;

    function selectedOptions() {
      return qsa(form, '[data-g99-option]').map(function (group) {
        var c = group.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function findVariant() {
      var sel = selectedOptions();
      return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === null || sel[i] === o; }); });
    }
    function currentOffer() { return form.querySelector('input[name="g99_offer"]:checked'); }

    function update() {
      var v = findVariant();
      qsa(form, '[data-g99-option-value]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-index'), 10); var sel = selectedOptions();
        el.textContent = sel[i] || '';
      });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      qsa(form, '[data-g99-price]').forEach(function (el) { el.textContent = v.price; });
      qsa(form, '[data-g99-compare]').forEach(function (el) {
        var key = el.getAttribute('data-g99-compare');
        var val = key === 'bundle' ? (v.bundle_compare || '') : (v.compare || '');
        el.textContent = val; el.hidden = !val;
      });
      var offer = currentOffer();
      qsa(form, '[data-g99-extra]').forEach(function (inp) {
        inp.disabled = !(offer && inp.getAttribute('data-g99-extra') === offer.value);
      });
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btnLabel : 'Sold out';
      }
      if (stock) {
        var show = v.available && v.tracked && v.qty > 0 && threshold > 0 && v.qty <= threshold;
        stock.hidden = !show;
        var n = stock.querySelector('[data-g99-qty]'); if (n) n.textContent = v.qty;
      }
      if (gallery && gallery.g99Show && v.media) gallery.g99Show(v.media);
      if (form.hasAttribute('data-update-url') && window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-g99-option] input, input[name="g99_offer"]')) update();
    });
    form.addEventListener('submit', function (e) {
      var v = findVariant(); if (!v || !v.available) { e.preventDefault(); }
    });
    update();
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    if (root.__g99) return; root.__g99 = true;
    var tabs = qsa(root, '[role="tab"]');
    function act(t) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = root.querySelector('#' + x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { act(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; act(n); n.focus();
      });
    });
  }

  /* ---------- Generic slider (scroll-snap) ---------- */
  function initSlider(root) {
    if (root.__g99) return; root.__g99 = true;
    var track = root.querySelector('.g99-track'); if (!track) return;
    var items = qsa(track, ':scope > *');
    var dotsWrap = root.querySelector('.g99-dots');
    function step() { return items[0] ? items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 24) : track.clientWidth; }
    qsa(root, '[data-g99-prev]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    qsa(root, '[data-g99-next]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    if (dotsWrap && items.length > 1) {
      items.forEach(function (it, i) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        dotsWrap.appendChild(d);
      });
      var dots = qsa(dotsWrap, 'button');
      function mark() {
        var idx = Math.round(track.scrollLeft / Math.max(1, step()));
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === Math.min(idx, dots.length - 1) ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true }); mark();
    }
  }

  /* ---------- Fade slider (quotes in buy box, tech banner cards) ---------- */
  function initFade(root) {
    if (root.__g99) return; root.__g99 = true;
    var slides = qsa(root, '[data-g99-fade-item]'); if (slides.length < 2) return;
    var dotsWrap = root.querySelector('.g99-dots'); var cur = 0; var dots = [];
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === cur ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === cur ? 'true' : 'false'); });
    }
    if (dotsWrap) slides.forEach(function (s, i) {
      var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Show item ' + (i + 1));
      d.addEventListener('click', function () { show(i); stop(); }); dotsWrap.appendChild(d); dots.push(d);
    });
    qsa(root, '[data-g99-prev]').forEach(function (b) { b.addEventListener('click', function () { show(cur - 1); stop(); }); });
    qsa(root, '[data-g99-next]').forEach(function (b) { b.addEventListener('click', function () { show(cur + 1); stop(); }); });
    var timer = null; var ms = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (ms > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { show(cur + 1); }, ms);
      root.addEventListener('mouseenter', stop); root.addEventListener('focusin', stop);
    }
    show(0);
  }

  function initAll(scope) {
    scope = scope || document;
    qsa(scope, '[data-g99-gallery]').forEach(initGallery);
    qsa(scope, 'form[data-g99-buy]').forEach(initBuy);
    qsa(scope, '[data-g99-tabs]').forEach(initTabs);
    qsa(scope, '[data-g99-slider]').forEach(initSlider);
    qsa(scope, '[data-g99-fade]').forEach(initFade);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('g99:init', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
